export { D as DelegableProtocolCallUseCase } from '../../../dist/DelegableProtocolCallUseCase-68560579.esm.js';
export { P as ProtocolCallUseCase } from '../../../dist/ProtocolCallUseCase-da9f73b0.esm.js';
import { _ as _asyncToGenerator, a as _regeneratorRuntime } from '../../../dist/asyncToGenerator-c002e3ca.esm.js';
import { c as _createClass, b as _classCallCheck, d as _defineProperty } from '../../../dist/createClass-3115abc1.esm.js';
import { success, invariant, failure } from '@lens-protocol/shared-kernel';
import { d as TransactionEvent } from '../../../dist/Transactions-f93c1e86.esm.js';
import '../../../dist/wrapNativeSuper-76ffa30e.esm.js';

var SignlessProtocolCallUseCase = /*#__PURE__*/function () {
  function SignlessProtocolCallUseCase(relayer, transactionQueue, presenter) {
    _classCallCheck(this, SignlessProtocolCallUseCase);
    this.relayer = relayer;
    this.transactionQueue = transactionQueue;
    this.presenter = presenter;
  }
  _createClass(SignlessProtocolCallUseCase, [{
    key: "execute",
    value: function () {
      var _execute = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(request) {
        var transaction;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.relayer.relaySignlessProtocolCall(request);
            case 2:
              transaction = _context.sent;
              _context.next = 5;
              return this.transactionQueue.push(transaction);
            case 5:
              this.presenter.present(success());
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function execute(_x) {
        return _execute.apply(this, arguments);
      }
      return execute;
    }()
  }]);
  return SignlessProtocolCallUseCase;
}();

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function () {};
      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true,
    didErr = false,
    err;
  return {
    s: function () {
      it = it.call(o);
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

function broadcastedTransactionData(tx) {
  invariant(tx.hash, 'Transaction must have a hash');
  return {
    id: tx.id,
    request: tx.request,
    txHash: tx.hash
  };
}
function transactionData(tx) {
  if (tx.hash) {
    return broadcastedTransactionData(tx);
  }
  return {
    id: tx.id,
    request: tx.request
  };
}
var TransactionQueue = /*#__PURE__*/function () {
  function TransactionQueue(responders, transactionGateway, transactionQueuePresenter) {
    _classCallCheck(this, TransactionQueue);
    _defineProperty(this, "initialized", false);
    this.responders = responders;
    this.transactionGateway = transactionGateway;
    this.transactionQueuePresenter = transactionQueuePresenter;
  }
  _createClass(TransactionQueue, [{
    key: "clearRecent",
    value: function clearRecent() {
      // This method might seem a bit weird, but it's actually a precursor to the
      // fully fledged solution which will store the transactions in the localStorage (at first).
      this.transactionQueuePresenter.clearRecent();
    }
  }, {
    key: "push",
    value: function () {
      var _push = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(transaction) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.transactionGateway.save(transaction);
            case 2:
              _context.next = 4;
              return this.handle(transaction);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function push(_x) {
        return _push.apply(this, arguments);
      }
      return push;
    }()
  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this = this;
        var transactions, _iterator, _step, transaction;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              invariant(!this.initialized, "".concat(TransactionQueue.name, " already initialized"));
              _context3.next = 3;
              return this.transactionGateway.getAll();
            case 3:
              transactions = _context3.sent;
              _iterator = _createForOfIteratorHelper(transactions);
              _context3.prev = 5;
              _iterator.s();
            case 7:
              if ((_step = _iterator.n()).done) {
                _context3.next = 13;
                break;
              }
              transaction = _step.value;
              _context3.next = 11;
              return this.handle(transaction);
            case 11:
              _context3.next = 7;
              break;
            case 13:
              _context3.next = 18;
              break;
            case 15:
              _context3.prev = 15;
              _context3.t0 = _context3["catch"](5);
              _iterator.e(_context3.t0);
            case 18:
              _context3.prev = 18;
              _iterator.f();
              return _context3.finish(18);
            case 21:
              this.transactionGateway.subscribe( /*#__PURE__*/function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(newTransactions) {
                  var _iterator2, _step2, transaction;
                  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                    while (1) switch (_context2.prev = _context2.next) {
                      case 0:
                        _iterator2 = _createForOfIteratorHelper(newTransactions);
                        _context2.prev = 1;
                        _iterator2.s();
                      case 3:
                        if ((_step2 = _iterator2.n()).done) {
                          _context2.next = 9;
                          break;
                        }
                        transaction = _step2.value;
                        _context2.next = 7;
                        return _this.handle(transaction);
                      case 7:
                        _context2.next = 3;
                        break;
                      case 9:
                        _context2.next = 14;
                        break;
                      case 11:
                        _context2.prev = 11;
                        _context2.t0 = _context2["catch"](1);
                        _iterator2.e(_context2.t0);
                      case 14:
                        _context2.prev = 14;
                        _iterator2.f();
                        return _context2.finish(14);
                      case 17:
                      case "end":
                        return _context2.stop();
                    }
                  }, _callee2, null, [[1, 11, 14, 17]]);
                }));
                return function (_x2) {
                  return _ref.apply(this, arguments);
                };
              }());
              this.initialized = true;
            case 23:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[5, 15, 18, 21]]);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }, {
    key: "handle",
    value: function () {
      var _handle = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(transaction) {
        var txData;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              txData = transactionData(transaction);
              _context4.next = 3;
              return this.prepare(txData);
            case 3:
              void this.observe(transaction);
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function handle(_x3) {
        return _handle.apply(this, arguments);
      }
      return handle;
    }()
  }, {
    key: "observe",
    value: function () {
      var _observe = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(transaction) {
        var transactionResult, _txData, txData;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return this.waitTransaction(transaction);
            case 2:
              transactionResult = _context5.sent;
              _context5.next = 5;
              return this.transactionGateway.remove(transaction.id);
            case 5:
              if (!transactionResult.isFailure()) {
                _context5.next = 10;
                break;
              }
              _txData = transactionData(transaction);
              _context5.next = 9;
              return this.rollback(transactionResult.error, _txData);
            case 9:
              return _context5.abrupt("return");
            case 10:
              txData = broadcastedTransactionData(transaction);
              _context5.next = 13;
              return this.commit(txData);
            case 13:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function observe(_x4) {
        return _observe.apply(this, arguments);
      }
      return observe;
    }()
  }, {
    key: "prepare",
    value: function () {
      var _prepare = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(txData) {
        var _responder$prepare;
        var responder;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              responder = this.getResponderFor(txData.request.kind);
              _context6.next = 3;
              return (_responder$prepare = responder.prepare) === null || _responder$prepare === void 0 ? void 0 : _responder$prepare.call(responder, txData);
            case 3:
              this.transactionQueuePresenter.broadcasting(txData);
            case 4:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function prepare(_x5) {
        return _prepare.apply(this, arguments);
      }
      return prepare;
    }()
  }, {
    key: "commit",
    value: function () {
      var _commit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(txData) {
        var responder;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              responder = this.getResponderFor(txData.request.kind);
              _context7.next = 3;
              return responder.commit(txData);
            case 3:
              this.transactionQueuePresenter.settled(txData);
            case 4:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function commit(_x6) {
        return _commit.apply(this, arguments);
      }
      return commit;
    }()
  }, {
    key: "rollback",
    value: function () {
      var _rollback = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(error, txData) {
        var _responder$rollback;
        var responder;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              responder = this.getResponderFor(txData.request.kind);
              _context8.next = 3;
              return (_responder$rollback = responder.rollback) === null || _responder$rollback === void 0 ? void 0 : _responder$rollback.call(responder, txData);
            case 3:
              this.transactionQueuePresenter.failed(error, txData);
            case 4:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function rollback(_x7, _x8) {
        return _rollback.apply(this, arguments);
      }
      return rollback;
    }()
  }, {
    key: "waitTransaction",
    value: function () {
      var _waitTransaction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(transaction) {
        var result;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              if (transaction.hash) {
                this.transactionQueuePresenter.mining(broadcastedTransactionData(transaction));
              }
              _context9.next = 4;
              return transaction.waitNextEvent();
            case 4:
              result = _context9.sent;
              if (!result.isFailure()) {
                _context9.next = 7;
                break;
              }
              return _context9.abrupt("return", failure(result.error));
            case 7:
              if (!(result.value === TransactionEvent.SETTLED)) {
                _context9.next = 9;
                break;
              }
              return _context9.abrupt("return", success());
            case 9:
              _context9.next = 11;
              return this.transactionGateway.save(transaction);
            case 11:
              _context9.next = 0;
              break;
            case 13:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function waitTransaction(_x9) {
        return _waitTransaction.apply(this, arguments);
      }
      return waitTransaction;
    }()
  }, {
    key: "getResponderFor",
    value: function getResponderFor(kind) {
      return this.responders[kind];
    }
  }]);
  return TransactionQueue;
}();

export { SignlessProtocolCallUseCase, TransactionQueue };
